<template>
  <div>
    <common-table 
      :table-columns="tableColumns" 
      :url="url" 
      :operate="[]" 
      :searchs="searchs" 
      :form-fields="formFields"
      :permission="permission"
    />
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable.vue";

export default {
  name: 'QianchuanCommissionRoi',
  components: { CommonTable },
  data() {
    return {
      // 搜索条件配置
      searchs: [
        {
          name: 'agentId',
          placeholder: '代理',
          type: 'select',
          selectUrl: '/agent/getAll', // 复用代理选择接口
          selectData: [],
        },
        {
          name: 'minCommission',
          placeholder: '最小佣金率(%)',
          type: 'input',
          inputType: 'number', // 数字输入
        },
        {
          name: 'targetRoi',
          placeholder: '目标ROI',
          type: 'input',
          inputType: 'number',
        }
      ],

      // 权限配置（前缀统一为实体类对应名称）
      permission: {
        add: 'qianchuanScheduleTask:add',
        update: 'qianchuanScheduleTask:update',
        delete: 'qianchuanScheduleTask:delete',
        deleteBatch: 'qianchuanScheduleTask:deleteBatch'
      },

      // 接口地址配置（前缀统一）
      url: {
        get: '/qianchuanCommissionRoi/listByCondition',
        add: '/qianchuanCommissionRoi/add',
        update: '/qianchuanCommissionRoi/update',
        delete: '/qianchuanCommissionRoi/delete',
        delete_batch: '/qianchuanCommissionRoi/deleteBatch',
        status: '/qianchuanCommissionRoi/status', // 如有状态切换需求
      },

      // 表格列配置（与实体字段一一对应）
      tableColumns: [
        {
          field: 'agentId',
          label: '代理',
          selectUrl: '/agent/getAll',
          selectData: [],
          show: {
            type: 'select',
          },
        },
        {
          field: 'minCommission',
          label: '佣金率(%)',
          sort: false,
          show: true,
          formatter: (row) => row.minCommission ? row.minCommission.toFixed(2) + '%' : '-' // 格式化显示百分比
        },
        {
          field: 'targetRoi',
          label: '目标ROI',
          sort: false,
          show: true,
          formatter: (row) => row.targetRoi ? row.targetRoi.toFixed(2) : '-' // 保留2位小数
        },
        {
          field: 'createTime',
          label: '创建时间',
          show: true,
        },
      ],

      // 表单配置（新增/修改弹窗字段）
      formFields: {
        addTitle: '添加佣金率配置',
        updateTitle: '修改佣金率配置',
        labelWidth: '110px',
        addGuide: {
          title: '佣金率与目标 ROI 配置说明',
          summary: '这张表单用于维护「佣金率 → 目标 ROI」的映射关系。定时投放任务选择「按佣金率配置 ROI」时，会按商品佣金率自动匹配这里的目标 ROI。',
          icon: 'el-icon-data-line',
          points: [
            '先选代理，再填写佣金率区间对应的目标 ROI。',
            '佣金率按百分比填写，例如 15.5 表示 15.5%。',
            '同一代理下建议按佣金率从低到高维护，避免区间重叠导致匹配混乱。'
          ]
        },
        model: [
          {
            field: 'agentId',
            label: '代理：',
            type: 'select',
            placeholder: '请选择代理',
            rules: [{ required: true, message: '请选择代理', trigger: 'blur' }],
            selectUrl: '/agent/getAll', // 复用代理选择接口
            selectData: [],
            add: true,
            update: true,
            filterable: true,
          },
          {
            field: 'minCommission',
            label: '佣金率(%)：',
            type: 'input',
            placeholder: '请输入佣金率（例如：15.5表示15.5%）',
            tip: '提示：表示达到该佣金率及以上时，使用下方配置的目标 ROI。',
            rules: [
              { required: true, message: '佣金率不能为空', trigger: 'blur' },
              { min: 0, message: '佣金率不能小于0', trigger: 'blur' }
            ],
            add: true,
            update: true,
          },
          {
            field: 'targetRoi',
            label: '目标ROI：',
            type: 'input',
            placeholder: '请输入目标ROI（例如：2.3表示2.3）',
            tip: '提示：投放任务命中该佣金率规则后，将使用此 ROI 创建计划。',
            rules: [
              { required: true, message: '目标ROI不能为空', trigger: 'blur' },
              { min: 0, message: '目标ROI不能小于0', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }
        ]
      },
      operate: []
    };
  }
};
</script>

<style scoped>

</style>